import React from 'react';
import ReactDOM from 'react-dom';
import FEPortalProps from './props';

const FEPortal = ({ children }: FEPortalProps) => {
  const [container, setContainer] = React.useState<HTMLDivElement | null>(null);

  React.useEffect(() => {
    const portalContainer = document.createElement('div');
    const visible = document.body.style.overflow !== 'hidden';
    document.body.appendChild(portalContainer);
    if (visible) document.body.style.overflow = 'hidden';
    setContainer(portalContainer);

    return () => {
      document.body.removeChild(portalContainer);
      if (visible) document.body.style.overflow = 'visible';
    };
  }, []);

  if (!container) return null;

  return ReactDOM.createPortal(children, container);
};

export default FEPortal;
export type { FEPortalProps };
